import { render, staticRenderFns } from "./AppDirectories.vue?vue&type=template&id=71793690&"
import script from "./AppDirectories.vue?vue&type=script&lang=js&"
export * from "./AppDirectories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports